<script setup lang="ts">
import { computed } from "vue";
import Buttons from "../form/Buttons.vue";

const props = withDefaults(defineProps<{
  mode: string;
  title: string | null;
  listCreateName?: string;
  noPermission: boolean;
  modal?: boolean;
  isReadOnly?: boolean;
  endPoint?: string;
  showEdit?: boolean
  onTour: boolean;
  showSave?: boolean;
  showSaveClose?: boolean;
  showSaveNew?: boolean;
  saveCloseCaption?: string
  saveCloseIcon?: string
}>(), {
  saveCloseCaption: "Save & Close",
  saveCloseIcon: "SaveOff",
  showSave: true,
  showSaveClose: true,
  showSaveNew: true,
});

defineEmits<{
  (e: "handleSubmit", close: boolean, newRecord: boolean): void;
  (e: "handleCancel"): void;
  (e: "handleEdit"): void;
  (e: "close"): void;
}>();

const fromSelect = computed(() => {
  return props.listCreateName || !props.endPoint?.includes("clients");
});
</script>
<template>
  <div
    class="p-2 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3 flex-shrink-0"
    id="form-footer-actions"
  >
    <Buttons
      id="form-edit"
      v-if="mode == 'view' && !fromSelect && showEdit"
      class="h-12 md:h-7"
      @click="$emit('handleEdit')"
      caption="Edit"
      icon="Pencil"
    />
    <Buttons
      id="form-cancel"
      v-if="mode == 'edit' && !fromSelect && showEdit"
      class="h-12 md:h-7"
      @click="$emit('handleCancel')"
      caption="Cancel"
      icon="CircleX"
    />
    <Buttons
      id="form-save-new"
      v-if="mode != 'view' && !fromSelect && modal && showSaveNew"
      class="h-12 md:h-7"
      @click="$emit('handleSubmit', false, true)"
      caption="Save & New"
      icon="FilePlus"
    />
    <Buttons
      id="form-save"
      v-if="mode != 'view' && !fromSelect && showSave"
      @click="$emit('handleSubmit', false, false)"
      caption="Save"
      class="h-12 md:h-7"
      icon="Save"
    />
    <Buttons
      id="form-save-close"
      v-if="mode != 'view' && modal && showSaveClose"
      @click="$emit('handleSubmit', true, false)"
      :caption="saveCloseCaption"
      class="h-12 md:h-7"
      :icon="saveCloseIcon"
    />
    <Buttons
      id="form-save-close"
      v-if="modal"
      @click="$emit('close')"
      caption="Close"
      class="h-12 md:h-7"
      icon="LogOut"
    />
  </div>
</template>
